import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/solid/music-fill.svg'
import _imports_1 from '@/assets/images/Crystal_Wedding_Logo_Submark_v2.svg'


const _withScopeId = n => (_pushScopeId("data-v-07413c0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "md:hidden truncate text-white w-full" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = ["max"]
const _hoisted_7 = {
  key: 0,
  class: "w-full flex items-center justify-between mt-3"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "hidden md:flex max-w-md w-full bg-zinc-600 h-13 rounded items-start" }
const _hoisted_10 = { class: "h-13 w-13 bg-zinc-500 relative flex-none rounded-l" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "flex justify-between items-center flex-col w-full h-full truncate relative" }
const _hoisted_13 = { class: "px-4 text-sm w-full text-center" }
const _hoisted_14 = {
  key: 0,
  class: "h-11 w-auto m-auto invert opacity-30",
  src: _imports_1,
  alt: "Heartful Logo"
}
const _hoisted_15 = { class: "truncate text-white" }
const _hoisted_16 = { class: "truncate text-zinc-300 px-7" }
const _hoisted_17 = ["max"]
const _hoisted_18 = { class: "hidden md:flex items-center gap-2 md:w-36 lg:w-48" }

import { // icons
		PlayIcon,
		PauseIcon,
		SpeakerWaveIcon,
		SpeakerXMarkIcon,
		XMarkIcon
	} from '@heroicons/vue/24/solid'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // vue
		ref,
		nextTick,
		watch,
		onUnmounted,
		onMounted
	} from 'vue'

	
	const __default__ = { name: 'NowPlaying' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		nowPlaying: {
			type: Object,
			default: () => {return {
				artist: '',
				songName: '',
				albumName: '',
				genre: '',
				signedUrl: '',
				artworkUrl: ''
			}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props, { expose: __expose }) {

	const props = __props

	const {t} = useI18n()
	
	const currentTime = ref(0)
	const duration = ref(0)
	const completedPercentage = ref(0)
	const style = ref('')
	const volumeSliderStyle = ref(`background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF  100%, #A1A1AA 100%, #A1A1AA 100%) !important;`)
	const loadedFile = ref(false)
	const paused = ref(true)
	const playing = ref(false)
	const volume = ref(1)
	const expanded = ref(false)

	__expose({
		expanded
	})

	function updateTrackTime() {
		currentTime.value =  Math.floor(document.getElementById('player')?.currentTime)
		completedPercentage.value = (currentTime.value / duration.value) * 100
		style.value = `background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF  ${completedPercentage.value}%, #A1A1AA ${completedPercentage.value}%, #A1A1AA 100%) !important;`
	}

	function updateDuration() {
		duration.value = document.getElementById('player')?.duration
	}

	function updatingLoading() {
		loadedFile.value = true
		document.getElementById('player')?.play()
	}

	function seekTrack(time: number) {
		document.getElementById('player').currentTime = currentTime.value
	}

	function setVolume() {
		document.getElementById('player').volume = volume.value
		// update slider
		let value = (volume.value / 1) * 100
		volumeSliderStyle.value = `background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF  ${value}%, #A1A1AA ${value}%, #A1A1AA 100%) !important;`
	}

	function muteVolume() {
		volume.value = 0
		setVolume()
	}

	function maxVolume() {
		volume.value = 1
		setVolume()
	}

	function onPlay() {
		playing.value = true
		paused.value = false
	}

	function onPause() {
		playing.value = false
		paused.value = true
	}

	function play(event: any) {
		event.preventDefault()
		document.getElementById('player').play()
	}
	
	function pause(event: any) {
		event.preventDefault()
		document.getElementById('player').pause()
	}

	function expandNowPlaying() {
		const width = window.innerWidth
		if(width < 768) {
			expanded.value = !expanded.value
		}
	}

	const windowWidth = ref(0)
	function onResize() {
		windowWidth.value =  window.innerWidth
		if(windowWidth.value >= 768 && expanded.value) expanded.value = false
	}
	
	onMounted(async () => {
		await nextTick()
		window.addEventListener('resize', onResize)
	})

	onUnmounted(() => { 
		window.removeEventListener('resize', onResize)
	})

	watch(() => props.nowPlaying, async () => {
		loadedFile.value = false
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", {
      id: "player",
      src: __props.nowPlaying.signedUrl,
      ontimeupdate: updateTrackTime,
      ondurationchange: updateDuration,
      onloadeddata: updatingLoading,
      onplay: onPlay,
      onpause: onPause,
      playsinline: "",
      autoplay: ""
    }, [
      _createElementVNode("source", {
        src: __props.nowPlaying.signedUrl,
        type: "audio/mpeg"
      }, null, 8, _hoisted_2),
      _createTextVNode(" " + _toDisplayString(_unref(t)("placeholders.audioNotSupported")), 1)
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (!expanded.value ? expandNowPlaying() : '')),
      class: _normalizeClass(["relative shadow-lg md:rounded-none md:m-0 md:px-8 lg:px-16 px-1.5 md:pt-3 md:pb-10 bg-zinc-800 w-full flex items-center justify-between transition-all origin-center duration-100 backdrop-blur overflow-hidden", [expanded.value ? 'flex-col h-dvh items-start justify-between gap-14 mx-0' : 'rounded-xl m-2 flex-row mb-18 h-15 md:h-24 z-[51] gap-2']])
    }, [
      (expanded.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "h-full w-full absolute top-0 left-0 block z-[-1] !bg-cover !bg-no-repeat !bg-center blur-3xl opacity-50 bg-zinc-500",
            style: _normalizeStyle('background: url(' + __props.nowPlaying.artworkUrl)
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["block md:hidden", {'flex-col items-start justify-center h-full': expanded.value}])
      }, [
        (expanded.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "aria-label": "Close now playing",
              class: "absolute top-6 left-6",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (expanded.value = !expanded.value), ["stop"]))
            }, [
              _createVNode(_unref(XMarkIcon), { class: "text-white h-6 w-6 flex-none" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["md:hidden bg-zinc-500 relative flex-none rounded-lg overflow-hidden shadow-lg transition-all duration-200", [{'w-52 h-52 mt-24' : expanded.value }, {'h-12 w-12' : !expanded.value} ]])
        }, [
          _withDirectives(_createElementVNode("img", {
            src: __props.nowPlaying.artworkUrl,
            alt: props.nowPlaying?.songName,
            class: "object-cover rounded-lg h-full w-full group-hover:opacity-50 transition-all duration-100"
          }, null, 8, _hoisted_3), [
            [_vShow, __props.nowPlaying.artworkUrl.length && !__props.loading && loadedFile.value]
          ]),
          _withDirectives(_createElementVNode("img", {
            class: _normalizeClass(["absolute grayed-icon w-1/2 -translate-y-1/2 -translate-x-1/2 left-1/2 top-1/2", {'animate-pulse': __props.nowPlaying.artworkUrl.length && (__props.loading || !loadedFile.value)}]),
            src: _imports_0,
            alt: "list icon"
          }, null, 2), [
            [_vShow, !__props.nowPlaying.artworkUrl.length || __props.loading || !loadedFile.value]
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full block md:hidden truncate", [expanded.value ? 'text-xl px-6 h-full justify-end flex flex-col' : 'text-base px-3']])
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.nowPlaying.songName), 1),
        _withDirectives(_createElementVNode("p", { class: "truncate text-zinc-200/75" }, _toDisplayString([__props.nowPlaying.artist, __props.nowPlaying.albumName].filter(Boolean).join('—')), 513), [
          [_vShow, expanded.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            style: _normalizeStyle(style.value),
            id: "track-seeker",
            type: "range",
            min: 0,
            max: duration.value,
            class: "slider w-full bottom-0 left-0 h-1 bg-zinc-400 rounded-br appearance-none cursor-pointer",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTime).value = $event)),
            onInput: seekTrack
          }, null, 44, _hoisted_6), [
            [_vShow, !__props.loading && loadedFile.value && __props.nowPlaying.signedUrl.length],
            [_vModelText, currentTime.value]
          ])
        ], 512), [
          [_vShow, expanded.value]
        ]),
        (expanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives(_createElementVNode("p", { class: "text-sm text-zinc-200/75" }, _toDisplayString(_ctx.$filters.secondsToTime(currentTime.value)), 513), [
                [_vShow, expanded.value && !__props.loading && loadedFile.value && __props.nowPlaying.signedUrl.length]
              ]),
              _withDirectives(_createElementVNode("p", { class: "text-sm text-zinc-200/75" }, _toDisplayString(_ctx.$filters.secondsToTime(duration.value)), 513), [
                [_vShow, expanded.value && !__props.loading && loadedFile.value && __props.nowPlaying.signedUrl.length]
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["flex gap-4 mr-2 md:mr-0 h-1/2 md:w-36 lg:w-48", [expanded.value ? 'items-start' : 'items-center']])
      }, [
        _withDirectives(_createElementVNode("button", {
          onClick: _withModifiers(play, ["stop"]),
          disabled: !__props.nowPlaying.signedUrl.length || __props.loading || !loadedFile.value,
          class: _normalizeClass({'opacity-50': !__props.nowPlaying.signedUrl.length || __props.loading || !loadedFile.value})
        }, [
          _createVNode(_unref(PlayIcon), {
            class: _normalizeClass(["text-slate-200 hover:text-slate-50", [expanded.value ? 'h-16 w-16' : 'h-6 w-6']])
          }, null, 8, ["class"])
        ], 10, _hoisted_8), [
          [_vShow, paused.value]
        ]),
        _withDirectives(_createElementVNode("button", {
          onClick: _withModifiers(pause, ["stop"])
        }, [
          _createVNode(_unref(PauseIcon), {
            class: _normalizeClass(["text-slate-200 hover:text-slate-50", [expanded.value ? 'h-16 w-16' : 'h-6 w-6']])
          }, null, 8, ["class"])
        ], 512), [
          [_vShow, playing.value]
        ])
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("img", {
            src: __props.nowPlaying.artworkUrl,
            alt: props.nowPlaying?.songName,
            class: "object-cover rounded-l h-full w-full group-hover:opacity-50"
          }, null, 8, _hoisted_11), [
            [_vShow, __props.nowPlaying.artworkUrl.length && !__props.loading && loadedFile.value]
          ]),
          _withDirectives(_createElementVNode("img", {
            class: _normalizeClass(["grayed-icon w-8 h-8 mx-auto translate-y-1/3 top-1/2", {'animate-pulse': __props.nowPlaying.artworkUrl.length && (__props.loading || !loadedFile.value)}]),
            src: _imports_0,
            alt: "list icon"
          }, null, 2), [
            [_vShow, !__props.nowPlaying.artworkUrl.length || __props.loading || !loadedFile.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (!__props.nowPlaying.signedUrl.length)
              ? (_openBlock(), _createElementBlock("img", _hoisted_14))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_15, _toDisplayString(__props.nowPlaying.songName), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString([__props.nowPlaying.artist, __props.nowPlaying.albumName].filter(Boolean).join('—')), 1)
          ]),
          _withDirectives(_createElementVNode("p", { class: "absolute left-2 bottom-[13px] text-xs text-zinc-200" }, _toDisplayString(_ctx.$filters.secondsToTime(currentTime.value)), 513), [
            [_vShow, !__props.loading && loadedFile.value && __props.nowPlaying.signedUrl.length]
          ]),
          _withDirectives(_createElementVNode("p", { class: "absolute right-2 bottom-[13px] text-xs text-zinc-200" }, _toDisplayString(_ctx.$filters.secondsToTime(duration.value)), 513), [
            [_vShow, !__props.loading && loadedFile.value && __props.nowPlaying.signedUrl.length]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass([{'animate-pulse': __props.nowPlaying.artworkUrl.length && (__props.loading || !loadedFile.value)}, "w-full bottom-0 left-0 h-1 bg-zinc-400 rounded-br"]),
            style: _normalizeStyle(style.value)
          }, null, 6), [
            [_vShow, __props.loading || !loadedFile.value || !__props.nowPlaying.signedUrl.length]
          ]),
          _withDirectives(_createElementVNode("input", {
            style: _normalizeStyle(style.value),
            id: "track-seeker",
            type: "range",
            min: 0,
            max: duration.value,
            class: "slider w-full bottom-0 left-0 h-1 bg-zinc-400 rounded-br appearance-none cursor-pointer",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentTime).value = $event)),
            onInput: seekTrack
          }, null, 44, _hoisted_17), [
            [_vShow, !__props.loading && loadedFile.value && __props.nowPlaying.signedUrl.length],
            [_vModelText, currentTime.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (muteVolume()))
        }, [
          _createVNode(_unref(SpeakerXMarkIcon), { class: "h-5 w-5 text-slate-200 hover:text-slate-50" })
        ]),
        _withDirectives(_createElementVNode("input", {
          style: _normalizeStyle(volumeSliderStyle.value),
          id: "volume-slider",
          type: "range",
          min: 0,
          max: 1,
          step: ".01",
          class: "volume-slider w-full appearance-none cursor-pointer",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((volume).value = $event)),
          onInput: setVolume
        }, null, 36), [
          [_vModelText, volume.value]
        ]),
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (maxVolume()))
        }, [
          _createVNode(_unref(SpeakerWaveIcon), { class: "h-5 w-5 text-slate-200 hover:text-slate-50" })
        ])
      ])
    ], 2)
  ], 64))
}
}

})